import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppRoot } from "@telegram-apps/telegram-ui";
import "@telegram-apps/telegram-ui/dist/styles.css";
import "./index.css";
import { initTelegram, getThemeAppearance, getPlatform } from "./lib/telegram.js";
import App from "./App.jsx";

initTelegram();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppRoot
      appearance={getThemeAppearance()}
      platform={getPlatform() === "ios" ? "ios" : "base"}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppRoot>
  </React.StrictMode>
);
